export default {
  STATUS: {
    NONE: 'none',
    PARTIAL: 'partial',
    ALL: 'all'
  }
}
